// Import Vue
import Vue from 'vue'
import Hist from './Wallet/Hist.vue'
import {get_el} from '@/comp/eto/misc.js'

function start_eto_wallethist( idOrEl ) {
    let el = get_el( idOrEl )

    if (el) {
        let id = el.id || 'eto_wallethist'
        new Vue({
            el,
            render: h => h(Hist, {
                props: { id, }
            }),
        })
    }
}

export {start_eto_wallethist}
